import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import Draggable from 'react-draggable'
import { ResizableBox } from 'react-resizable'
import 'react-resizable/css/styles.css'
import styles from './_pip.module.scss'

interface PipProps {
  isVisible: boolean
  title: string
  children?: React.ReactNode
}

const PIP: React.FC<PipProps> = ({ isVisible, title, children }) => {
  const width = 320
  const height = 180
  const minConstraints = [320, 180]
  const maxConstraints = [640, 360]

  const [isOpen, setIsOpen] = useState(isVisible)

  useEffect(() => {
    if (isVisible) setIsOpen(isVisible)
    else {
      setTimeout(() => {
        setIsOpen(false)
      }, 500)
    }
  }, [isVisible])

  return (
    isOpen && (
      <div>
        <Draggable>
          <div
            className={classNames(styles.pipWindow, {
              [styles.close]: !isVisible
            })}
          >
            <div className={styles.pipHeader}>
              {title}
              <button
                type="button"
                className={styles.closeButton}
                onClick={() => {
                  setIsOpen(false)
                }}
              >
                <FontAwesomeIcon
                  aria-hidden="true"
                  icon={faTimes}
                  className={styles.closeButtonIcon}
                />
              </button>
            </div>

            <ResizableBox
              onMouseDown={(e) => {
                e.stopPropagation()
              }}
              className={styles.pipResizableContent}
              width={width}
              height={height}
              minConstraints={minConstraints}
              maxConstraints={maxConstraints}
              //resizeHandles={['s', 'w', 'e', 'n', 'sw', 'nw', 'se', 'ne']}
              resizeHandles={['sw']}
              lockAspectRatio={true}
            >
              {children}
            </ResizableBox>
          </div>
        </Draggable>
      </div>
    )
  )
}

export default PIP
